import { useCallback, useMemo } from "react";

import { getToday } from "@/services/Utils";
import { enqueueExcelExport } from "@/services/exportQueue.service";
import useFilterStore from "@/stores/useFilterStore";

export const usePhytosanitaryExport = (appliedFilterParams, tableState) => {
	const { estate_id, estate_parent_id } = useFilterStore((state) => state.filter);

	const queueExcelDownload = useCallback(({ url, name, params, api }) => {
		enqueueExcelExport({
			url,
			name,
			params,
			api,
		});
	}, []);

	const mappedExportParams = useMemo(
		() => ({
			estate_id,
			estate_parent_id,
			...appliedFilterParams,
			...tableState,
		}),
		[appliedFilterParams, estate_id, estate_parent_id, tableState],
	);

	const handleExport = useCallback(
		(activeSpeciesId) => {
			const fileName = `${getToday()} Programa Fitosanitario.xlsx`;

			queueExcelDownload({
				url: "/app/planning/phytosanitary_program/export",
				name: fileName,
				api: "go",
				params: {
					...mappedExportParams,
					species_id: activeSpeciesId || undefined,
				},
			});
		},
		[mappedExportParams, queueExcelDownload],
	);

	return { handleExport };
};
